export const PAPER_PDP_IS_ADMIN_VIEW = 'PAPER_PDP_IS_ADMIN_VIEW';
